import { useEffect } from "react";
import { useNavigate, useLocation, Navigate } from "react-router-dom";
import { toast } from "sonner";
import { useAuth } from "@/context/AuthContext";
import { Camera } from "lucide-react";
import { Button } from "@/components/ui/button";

export default function Login() {
  const { user, loading } = useAuth();
  const location = useLocation();

  useEffect(() => {
    const err = new URLSearchParams(location.search).get("error");
    if (err) toast.error(err);
  }, [location.search]);

  if (!loading && user) return <Navigate to="/dashboard" replace />;

  const signIn = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + "/dashboard";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <div className="min-h-screen relative z-[2] flex flex-col lg:flex-row">
      <div className="hidden lg:block lg:w-1/2 relative overflow-hidden border-r border-border">
        <img src="https://images.unsplash.com/photo-1649110458068-fc092543c056?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400"
          alt="Film rolls" className="absolute inset-0 w-full h-full object-cover" />
        <div className="absolute inset-0 bg-gradient-to-t from-background via-background/70 to-background/30" />
        <div className="absolute bottom-0 left-0 p-12">
          <p className="mono text-xs uppercase tracking-[0.3em] text-brand mb-3">Est. Analog</p>
          <h2 className="font-heading text-4xl font-bold leading-tight max-w-md">Every frame, tracked from intake to delivery.</h2>
        </div>
      </div>

      <div className="flex-1 flex items-center justify-center p-8">
        <div className="w-full max-w-sm">
          <div className="flex items-center gap-3 mb-10">
            <div className="w-11 h-11 rounded-xl bg-brand flex items-center justify-center">
              <Camera className="w-6 h-6 text-primary-foreground" />
            </div>
            <div>
              <div className="font-heading font-bold text-lg leading-none">Low Five Film Lab</div>
              <div className="mono text-[10px] uppercase tracking-[0.2em] text-muted-foreground mt-1">Operations Console</div>
            </div>
          </div>

          <h1 className="font-heading text-3xl font-bold tracking-tight mb-2">Staff sign in</h1>
          <p className="text-muted-foreground text-sm mb-8 leading-relaxed">
            This console is for lab employees only. Sign in with your authorized Google account to manage orders and stations.
          </p>

          <Button onClick={signIn} data-testid="google-signin-btn"
            className="w-full h-12 bg-brand hover:bg-brand-hover text-primary-foreground font-semibold text-[15px]">
            Continue with Google
          </Button>

          <p className="mono text-[11px] text-muted-foreground mt-6 leading-relaxed">
            Access is restricted to allow-listed lab staff. Contact the lab owner if you need access.
          </p>
        </div>
      </div>
    </div>
  );
}
